module.exports = __webpack_public_path__ + "img/refuseOrder@2x.6b5cf815.png";